import { Card, Col, Form, Row } from "react-bootstrap";
import ESBarGraph from "../../controls/ESBarGraph";
import ESSearchDropdown from "../../controls/ESSearchDropdown";
import { useContext, useEffect, useState } from "react";
import { axiosPost } from "../../utils/AxiosHelper";
import {
  getAllSurveyAssignments,
  getEmployeeEngagementDetailsBySurvey,
} from "../../utils/ApiUrl";
import { FormProvider, useForm } from "react-hook-form";
import { UserContext } from "../../routes/routes";
import { fetchSurveyAssignments } from "../../utils/common";

interface Props {
  selectedSurvey: any;
  setSelectedSurvey: any;
  isSurveySelected: any;
  setIsSurveySelected: any;
}

interface Option {
  label: string;
  value: number;
}

interface EmployeeEngagementInfo {
  Title: string;
  Count: number;
}

export default function EmployeeEngagementSurveyBarChart(props: Props) {
  const {
    selectedSurvey,
    setSelectedSurvey,
    isSurveySelected,
    setIsSurveySelected,
  } = props;
  const { appContextdata, setAppContextdata } = useContext<any>(UserContext);
  const [surveyAssignments, setSurveyAssignments] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [employeeEngagementDetails, setEmployeeEngagementDetails] = useState<
    EmployeeEngagementInfo[]
  >([]);
  const methods = useForm<any>({
    defaultValues: {
      SurveyFormId: null,
      AssestmentTypeId: null,
    },
  });

  useEffect(() => {
    if (appContextdata?.Organization) {
      setEmployeeEngagementDetails([]);
      fetchDataForOrganization();
    }
  }, [appContextdata?.Organization]);

  const fetchDataForOrganization = async () => {
    await loadSurveyAssignments();
  };

  const loadSurveyAssignments = async () => {
    setLoading(true);
    const assignments = await fetchSurveyAssignments(appContextdata, 0);
    setSurveyAssignments(assignments);
    setLoading(false);
  };
  useEffect(() => {
    loadSurveyAssignments();
  }, []);

  const handleSurveyChange = async (value: Option | null) => {
    if (value) {
      setIsSurveySelected(true);
      setSelectedSurvey(value);
      await fetchDashboardStatisticsInfo(value.value);
    } else {
      setIsSurveySelected(false);
      setSelectedSurvey({});
      methods.reset({
        SurveyAssignmentId: null,
      });
    }
  };

  const fetchDashboardStatisticsInfo = async (
    SurveyAssignmentId: number | null
  ) => {
    setLoading(true);
    try {
      const response: any = await axiosPost(
        getEmployeeEngagementDetailsBySurvey,
        {
          OrganizationId: appContextdata?.Organization || 0,
          SurveyAssignmentId: SurveyAssignmentId || 0,
        }
      );
      const data = response.data.ExtraData || [];
      setEmployeeEngagementDetails(data);
    } catch (error) {
      console.error("Error fetching dashboard statistics:", error);
    } finally {
      setLoading(false);
    }
  };

  const surveyAssignmentOptions = surveyAssignments?.map((survey) => ({
    label: survey.SurveyFormTitle,
    value: survey.SurveyAssignmentId,
  }));

  return (
    <>
      {surveyAssignmentOptions?.length > 0 ? (
        <div className="employee-engagement-chart">
          <Row>
            <Col md="12" xs="12">
              <Card className={`grey-color `}>
                <div className="card-content">
                  <Row>
                    <Col md="4"></Col>
                    <FormProvider {...methods}>
                      <Form.Group as={Col} md="2">
                        <Form.Label className="mt-1 d-none">
                          Select Form
                        </Form.Label>
                      </Form.Group>
                      <Form.Group as={Col} md="6">
                        <ESSearchDropdown
                          name="SurveyAssignmentId"
                          placeholder="Survey Form"
                          options={surveyAssignmentOptions}
                          defaultValue={selectedSurvey}
                          onChange={handleSurveyChange}
                        />
                      </Form.Group>
                    </FormProvider>
                  </Row>
                  {error && <p>{error}</p>}
                  {isSurveySelected && (
                    <Row>
                      <div className="survey-engagement-barchart">
                        <ESBarGraph
                          title="Employee Engagement Survey"
                          data={employeeEngagementDetails}
                        />
                      </div>
                    </Row>
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
